module.exports = __webpack_public_path__ + "static/Hedwig-vendor-pic-e2ba2292c1100dc0eff0a5bc73b825ad.svg";